import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
  import Chart, {
    ChartConfiguration,
    BarControllerChartOptions,
    DoughnutControllerChartOptions,
  } from "chart.js/auto";

  interface ChartProps {
    labels: string[];
    setData: number[];
    backgroundColor: string[];
    title: string;
    chartType: "bar" | "doughnut";
    options: BarControllerChartOptions | DoughnutControllerChartOptions;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ChartForReports',
  props: {
    labels: {},
    setData: {},
    backgroundColor: {},
    title: {},
    chartType: {},
    options: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;
  const chartCanvas = ref<HTMLCanvasElement | null>(null);
  const chartError = ref(false);

  const initializeChart = () => {
    const ctx = chartCanvas.value;

    if (!ctx) {
      return (chartError.value = true);
    }

    const dataToChart = {
      labels: props.labels,
      datasets: [
        {
          label: props.title,
          data: props.setData,
          backgroundColor: props.backgroundColor,
          borderWidth: 1,
        },
      ],
    };

    const chartConfig: ChartConfiguration<
      "bar" | "doughnut",
      number[],
      string
    > = {
      type: props.chartType,
      data: dataToChart,
      options: props.options,
    };

    return new Chart(ctx, chartConfig);
  };

  onMounted(() => {
    initializeChart();
  });

const __returned__ = { props, chartCanvas, chartError, initializeChart, onMounted, ref, get Chart() { return Chart }, get ChartConfiguration() { return ChartConfiguration }, get BarControllerChartOptions() { return BarControllerChartOptions }, get DoughnutControllerChartOptions() { return DoughnutControllerChartOptions } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})